import _ from 'lodash';
import { _fetchModes } from '../../../elements/matches/MatchDataUpdate';
import { _mediaHeaders } from '../SportsDataReducer';

export const _teamsFoundTypes = {
  bothTeams: 'bothTeams',
  singleTeam: 'singleTeam',
  noTeams: 'noTeams'
}

export const _matchFoundTypes = {
  cancelled: 'cancelled',
  dateChanged: 'dateChanged',
  duplicated: 'duplicated',
  exhibition: 'exhibition',
  existingDb: 'existingDb',
  inversed: 'inversed',
  matchIsNew: 'matchIsNew',
  new: 'new',
  nonDistrict: 'nonDistrict',
  removed: 'removed',
  scoreChanged: 'scoreChanged',
  scoreIsNew: 'scoreIsNew',
}
